const wishlistTransactionSchema = {
  eventType: "wishlistTransaction",
  required: ["name", "price", "shippingPrice", "itemId"],
  optional: ["user_agent", "timestamp"],
  validate: (data) => {
    if (data.name != null && typeof data.name !== "string") {
      throw new Error("wishlist item name must be a string");
    }
    if (!data.price || typeof data.price !== "number") {
        throw new Error("wishlist item price must be a number");
    }
    if (typeof data.shippingPrice !== "number") {
        throw new Error("wishlist item shipping must be a number");
    }
    if (!data.itemId || typeof data.itemId !== "string") {
      throw new Error("wishlist itemId must be a string");
    }
    return true;
  },
  createEventData: (item) => {
    return {
      item_name: item.name,
      item_price: item.price,
      item_shipping: item.shippingPrice,
      item_id: item.itemId,
      user_agent: navigator.userAgent || null,
      timestamp: new Date().toISOString(),
      page_url: window.location.href,
    };
  },
};

module.exports = wishlistTransactionSchema;
